import React, { useState } from "react";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";

export const ResolutionComment = React.createContext(null);

export const ResolutionCommentContext = props => {
    const offlineService = new OfflineService();
    const [resolutions, setResolutions] = useState([]);
    const [comments, setComments] = useState([]);

    const getResolutions = () => {
        HttpService.post('/Home/GetResolutions')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(0, "Resolutions");
                result = offlineResult.OfflineData;
            }
            setResolutions(result);
        },
        (error) => {
            console.log(error);
        });
    }

    const getComments = () => {
        HttpService.post('/Home/GetComments')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(0, "Comments");
                result = offlineResult.OfflineData;
            }
            setComments(result);
        },
        (error) => {
            console.log(error);
        });
    }

    return (
        <>
            <ResolutionComment.Provider value={{ resolutions, getResolutions, comments, getComments }}>
                {props.children}
            </ResolutionComment.Provider>
        </>
    );
}
